import { setGoogleAnalyticsEvent } from "src/common";
import { LabelWithOptionalIcon } from "./LabelWithOptionalIcon";
import { ElementType } from "react";
import { useLightMode } from "src/common/hooks/lightMode";
import { useTranslate } from "@tolgee/react";

export const getAsideMenuLinkClass = ({
  isSmall,
  isChild,
  inPopover,
}: {
  isSmall?: boolean;
  isChild?: boolean;
  inPopover?: boolean;
}) => {
  let className = "asidemenu-link";
  if (isSmall) className += " small";
  if (isChild) {
    className += " child";
    if (inPopover) {
      className += " paddingLeftSm";
    } else {
      className += " paddingLeftLg";
    }
  }
  return className;
};

export const WidgetLink = ({
  inPopover,
  isChild,
  isSmall,
  item,
  LeftIcon,
}: {
  inPopover?: boolean;
  isChild?: boolean;
  isSmall?: boolean;
  item: any;
  LeftIcon?: ElementType;
}) => {
  const { lightMode } = useLightMode();
  const { t } = useTranslate();
  const itemLabel = item.hasCustomName
    ? item.name
    : t({ key: item.translatorDefaultNameKey, defaultValue: item.name });

  return (
    <a
      href={`#widget${item.id}`}
      data-aut={`Aside|WidgetLink|${itemLabel}`}
      onClick={() => {
        setGoogleAnalyticsEvent({
          action: "portal_dashboard_widget_click",
          category: item.identifier,
        });
      }}
      className={getAsideMenuLinkClass({ inPopover, isChild, isSmall })}
      aria-label={isSmall ? itemLabel : undefined}
      title={isSmall ? itemLabel : undefined}
    >
      {isSmall ? (
        <LeftIcon
          fontSize="22px"
          aria-hidden
          color={lightMode ? "var(--chakra-colors-gray-500)" : "#C7C7C7"}
        />
      ) : (
        <LabelWithOptionalIcon label={itemLabel} LeftIcon={LeftIcon} />
      )}
    </a>
  );
};
